import { Images } from '../../config/images';
import { ImageIcon } from './ImageIcon';

export const EntityBuilding = (props) => <ImageIcon {...props} src={Images.entityBuilding} />;
